export const C_BUSINESS_DETAILS_ID = {
  WHITES: 2,
  FURNISHED: 1,
  NONE: 0
};

export const C_BUSINESS_DETAILS_VALUE = {
  WHITES: "whites",
  FURNISHED: "furnished",
  NONE: "none"
};

export type T_BUSINESS_DETAILS_VALUE =
  keyof typeof C_BUSINESS_DETAILS_VALUE;

export const C_BUSINESS_DETAILS = {
  WHITES: {
    id: C_BUSINESS_DETAILS_ID.WHITES,
    name: "Línea Blanca",
    value: C_BUSINESS_DETAILS_VALUE.WHITES,
    label: "Línea Blanca"
  },
  FURNISHED: {
    id: C_BUSINESS_DETAILS_ID.FURNISHED,
    name: "Amueblado",
    value: C_BUSINESS_DETAILS_VALUE.FURNISHED,
    label: "Amueblado"
  },
  NONE: {
    id: C_BUSINESS_DETAILS_ID.NONE,
    name: "Ninguno",
    value: C_BUSINESS_DETAILS_VALUE.NONE,
    label: "Ninguno"
  }
};

const { FURNISHED, NONE, WHITES } = C_BUSINESS_DETAILS;

const C_BUSINESS_DETAIL = {
  FURNISHED,
  NONE,
  WHITES
};

export const O_BUSINESS_DETAIL = {
  [C_BUSINESS_DETAIL.FURNISHED.id]: C_BUSINESS_DETAIL.FURNISHED,
  [C_BUSINESS_DETAIL.NONE.id]: C_BUSINESS_DETAIL.NONE,
  [C_BUSINESS_DETAIL.WHITES.id]: C_BUSINESS_DETAIL.WHITES
};

export const A_BUSINESS_DETAILS = [
  C_BUSINESS_DETAILS.WHITES,
  C_BUSINESS_DETAILS.FURNISHED,
  C_BUSINESS_DETAILS.NONE
];
